// BlogPost1Page.js
import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog1 from "../images/photo1.jpg";
import pr1 from "../images/pronunciation1.jpg";
import pr2 from "../images/pronunciation2.jpg";
import { motion } from 'framer-motion';




const BlogPost1Page = ({ post }) => {
  
  return (
    <>
      <Nav />
      <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
        <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
          <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
            <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
              I need to use English at my new job
            </Typography>
            <div id="image-container" className="absolute top-20 left-0">
              <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
            </div>
            <div id="image-container2" className="absolute top-20 right-80">
              <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
            </div>
            <div id="image-container3" className="absolute top-120 right-40">
              <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
            </div>
            <div id="image-container3" className="absolute bottom-20 right-0">
              <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
            </div>
          </Container>
        </Box>

        <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
          <Grid container spacing={5} alignItems="flex-start" mb={4}>
            <Grid item xs={12} lg={6}>
              <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                I couldn’t believe it when I was invited for the job interview. Just imagine my surprise when they told me I got hired.
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                However, there is a catch! Since my new employer is an international company they rely on English for conducting all daily tasks and in their meetings. Besides, they use it in correspondence with their international partners. They also told me to be ready to attend the training as a newbie. Needless to say, of course, it’s going to be conducted in English.
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                Gosh, but my pronunciation isn’t that good when I think of it. That’s one of the reasons I was overwhelmed and surprised when hired me in the first place.
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                I guess I better start working on my pronunciation, but how should I go about it?
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                As you know understanding English phonetics (sounds actually) can greatly assist in speaking English correctly as a second language. By mastering the specific sounds and their production mechanisms, you can refine their pronunciation to sound more natural and be better understood by native speakers.
              </Typography>
              <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                But still - easier said than done, right? Let’s have a look, shall we?
              </Typography>

            </Grid>
            <Grid item xs={12} lg={6}>
              <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                <CardMedia
                  component="img"
                  image={blog1}
                  alt="Fresh Start"
                  sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                />
              </motion.div>
            </Grid>
          </Grid>

          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', fontFamily: 'Arial, sans-serif' }} >
            Let’s check some examples:
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
            Articulation Practice: Learning the phonetic characteristics of English sounds helps learners articulate them accurately. For instance, knowing that the English <i><b> "th" sound (/θ/ and /ð/)</b></i> is produced by placing the tongue between the teeth can help learners pronounce words like<i><b> "think" or "this"</b></i> correctly.
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
            Minimal Pair Differentiation: Recognizing subtle <i><b> differences between similar sounds,</b></i> known as minimal pairs, is crucial. For example,<i><b> distinguishing between /ɪ/ (as in "bit") and /i:/ (as in "beat")</b></i> helps learners avoid mispronunciations that could alter the meaning of words.
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
            Stress and Intonation: Understanding phonetics assists in mastering stress and intonation patterns. Proper stress placement and intonation can significantly enhance communication clarity. For instance, knowing the stress pattern in compound nouns like<b> "blackboard"</b><b><i> (stress on the first syllable) </i></b>helps learners sound more fluent.
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
            As you can see, pronunciation is present in all aspects of our life. Why don’t you check some of my <i><b>videos</b></i> (youtube link) where I have explained the most common mistakes people make and how to fix them?
          </Typography>
          <Grid item xs={12} lg={11} container spacing={2}>
            <Grid item xs={6} paddingBottom={'20px'}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <CardMedia
                  component="img"
                  image={pr1}
                  alt="Fresh Start"
                  sx={{ borderRadius: 2 }}
                />
              </motion.div>
            </Grid>
            <Grid item xs={6}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <CardMedia
                  component="img"
                  image={pr2}
                  alt="Fresh Start"
                  sx={{ borderRadius: 2 }}
                />
              </motion.div>
            </Grid>
          </Grid>
        </Container >
      </Box >
    </>
  );
};

export default BlogPost1Page;
